module.exports = __webpack_public_path__ + "img/signin_icon__scan_normal.8775e761.svg";